import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetUserFavoriteAssetsParams,
  BackendErrorEntity,
  CreateUserFavoriteAssetResponseDto,
  CreateUserFavoriteAssetsBodyDto,
  DeleteUserFavoriteAssetsBodyDto,
  GetUserFavoriteAssetsResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiCreateUserFavoriteAsset = (
    createUserFavoriteAssetsBodyDto: MaybeRef<CreateUserFavoriteAssetsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      createUserFavoriteAssetsBodyDto = unref(createUserFavoriteAssetsBodyDto);
      
      return fetchApiInstance<CreateUserFavoriteAssetResponseDto>(
      {url: `/userFavoriteAsset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserFavoriteAssetsBodyDto
    },
      options);
    }
  


export const getApiCreateUserFavoriteAssetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>, TError,{data: BodyType<CreateUserFavoriteAssetsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>, TError,{data: BodyType<CreateUserFavoriteAssetsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>, {data: BodyType<CreateUserFavoriteAssetsBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCreateUserFavoriteAsset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCreateUserFavoriteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>>
    export type ApiCreateUserFavoriteAssetMutationBody = BodyType<CreateUserFavoriteAssetsBodyDto>
    export type ApiCreateUserFavoriteAssetMutationError = ErrorType<BackendErrorEntity>

    export const useApiCreateUserFavoriteAsset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>, TError,{data: BodyType<CreateUserFavoriteAssetsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCreateUserFavoriteAsset>>,
        TError,
        {data: BodyType<CreateUserFavoriteAssetsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCreateUserFavoriteAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteUserFavoriteAsset = (
    deleteUserFavoriteAssetsBodyDto: MaybeRef<DeleteUserFavoriteAssetsBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      deleteUserFavoriteAssetsBodyDto = unref(deleteUserFavoriteAssetsBodyDto);
      
      return fetchApiInstance<void>(
      {url: `/userFavoriteAsset`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteUserFavoriteAssetsBodyDto
    },
      options);
    }
  


export const getApiDeleteUserFavoriteAssetMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>, TError,{data: BodyType<DeleteUserFavoriteAssetsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>, TError,{data: BodyType<DeleteUserFavoriteAssetsBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>, {data: BodyType<DeleteUserFavoriteAssetsBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiDeleteUserFavoriteAsset(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteUserFavoriteAssetMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>>
    export type ApiDeleteUserFavoriteAssetMutationBody = BodyType<DeleteUserFavoriteAssetsBodyDto>
    export type ApiDeleteUserFavoriteAssetMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteUserFavoriteAsset = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>, TError,{data: BodyType<DeleteUserFavoriteAssetsBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteUserFavoriteAsset>>,
        TError,
        {data: BodyType<DeleteUserFavoriteAssetsBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiDeleteUserFavoriteAssetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetUserFavoriteAssets = (
    params?: MaybeRef<ApiGetUserFavoriteAssetsParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetUserFavoriteAssetsResponseDto>(
      {url: `/userFavoriteAsset`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetUserFavoriteAssetsQueryKey = (params?: MaybeRef<ApiGetUserFavoriteAssetsParams>,) => {
    return ['userFavoriteAsset', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetUserFavoriteAssetsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetUserFavoriteAssetsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetUserFavoriteAssetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>> = () => apiGetUserFavoriteAssets(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>, TError, TData> 
}

export type ApiGetUserFavoriteAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>>
export type ApiGetUserFavoriteAssetsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetUserFavoriteAssets<TData = Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetUserFavoriteAssetsParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetUserFavoriteAssets>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetUserFavoriteAssetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



